import * as React from 'react';
import { HashRouter as Router, RouteComponentProps } from 'react-router-dom';
import { Route, Switch } from 'react-router';
import Inspection from './routes/inspection/Inspection';
import Layout from './components/Layout';
import { Languages } from './shared/language/Language';
import LanguageSetter from './components/LanguageSetter';
import SuccessPage from './routes/responsePage/SuccessPage';
import ErrorPage from './routes/responsePage/ErrorPage';
import Disclosure from './routes/disclosure/Disclosure';
import { languageActions } from './modules/language';
import { connect } from 'react-redux';

interface DispatchProps {
  setLanguage: typeof languageActions.setLanguage;
}

type Props = DispatchProps;

class App extends React.Component<Props> {
  onLanguageChange = (language: Languages) => {
    this.props.setLanguage({ language });
  };

  public render() {
    return (
      <Layout onLanguageChange={this.onLanguageChange}>
        <Router>
          <>
            <Switch>
              <Route
                path="/de"
                render={() => <LanguageSetter onLanguageChange={this.onLanguageChange} language="de" />}
              />
              <Route
                path="/en"
                render={() => <LanguageSetter onLanguageChange={this.onLanguageChange} language="en" />}
              />
            </Switch>
            <Switch>
              <Route path="/success" component={SuccessPage} exact />
              <Route path="/error" component={ErrorPage} exact />
              <Route
                path="/:lng/inspection/:type/:id"
                render={(props: RouteComponentProps<any>) => <Inspection {...props} />}
              />
              <Route
                path="/:lng/disclosure/:id"
                render={(props: RouteComponentProps<any>) => <Disclosure {...props} />}
              />
            </Switch>
          </>
        </Router>
      </Layout>
    );
  }
}

const mapDispatchToProps = {
  setLanguage: languageActions.setLanguage,
};

export default connect(
  null,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.tsx